import { nullableInput } from '@/features/form/utils/nullableInput'
import { DeliveryTypeCategory } from '@/features/orders/constants/app'
import { DeliveryTimeType } from '@/features/orders/constants/delivery-time'
import {
    FormCustomerKeys,
    FormKeys,
} from '@/features/pos/components/OrderFinalization/form/constants'
import { z } from 'zod/v4'

const deliveryTypeCategory = z.enum(DeliveryTypeCategory)

const automaticContainerRemoval = z.union([
    z.object({
        cartItemUuid: z.string(),
        cartItemAddedProductVariantUuid: z.never().optional(),
    }),
    z.object({
        cartItemUuid: z.never().optional(),
        cartItemAddedProductVariantUuid: z.string(),
    }),
])

export const posSchema = z.object({
    [FormKeys.DeliveryTypeCategory]: deliveryTypeCategory,
    [FormKeys.Note]: z.string().nullable(),
    [FormKeys.AutomaticContainerRemovals]: z.array(automaticContainerRemoval),
})

const address = z
    .object({
        address: z.string().nonempty(),
        coordinates: z.object({ latitude: z.number(), longitude: z.number() }),
        zone: z.string().nonempty(),
    })
    .optional()

const customer = z.object({
    [FormCustomerKeys.Phone]: z
        .string()
        .nonempty({ error: 'pos.orderFinalization.inputs.requiredFieldsMissing', abort: true }),
    [FormCustomerKeys.Name]: z.string(),
    [FormCustomerKeys.Address]: address,
})

const asap = z.object({ duration: z.number() })
const timed = z.object({
    type: z.enum(DeliveryTimeType),
    start: z.iso.datetime({ offset: true }),
    end: z.iso.datetime({ offset: true }),
})
const deliveryTime = z.union([z.object({ asap }), z.object({ timed })])

export const phoneSchema = z
    .object({
        [FormKeys.DeliveryTypeCategory]: deliveryTypeCategory,
        [FormKeys.Customer]: nullableInput(
            customer,
            'pos.orderFinalization.inputs.requiredFieldsMissing'
        ),
        [FormKeys.DeliveryTime]: nullableInput(deliveryTime, 'form.requiredFieldError', false),
        [FormKeys.Note]: z.string().nullable(),
        [FormKeys.AutomaticContainerRemovals]: z.array(automaticContainerRemoval),
    })
    .refine(
        ({ deliveryTypeCategory, customer }) =>
            deliveryTypeCategory !== DeliveryTypeCategory.Delivery || !!customer.address,
        {
            path: [`${FormKeys.Customer}.${FormCustomerKeys.Address}`],
            error: 'pos.orderFinalization.inputs.requiredFieldsMissing',
        }
    )
